import { useSelector } from "react-redux"

import { selectCurrentOrgId } from "features/store/orgSlice"
import { useConductorQuery } from "features/api"

interface useConductorProps {
  id: number | undefined
}

const useConductor = ({ id }: useConductorProps) => {
  const orgId = useSelector(selectCurrentOrgId)

  const {
    data: conductor,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useConductorQuery(
    {
      id: Number(id),
    },
    {
      skip: !orgId || !id,
    },
  )

  return { conductor, isFetching, isLoading, isError, isSuccess }
}

export default useConductor
